import { useMemo } from 'react';
import { MultiColumns as MultiColumnsPortal } from '@uaveiro/ui';
import { withPortalProviders } from 'modules/utils';

const MultiColumns = (props) => {
  const computedProps = useMemo(() => {
    // do the convertion logic here
    const { isThemeReverse, href, ...cardsProps } = props
    const titleColor = isThemeReverse ? '#fff' : '#000';
    const hasLine = props.href !== null && props.href !== '';
    const newProps = {
      titleColor, hasLine, href, isThemeReverse, activeColor: titleColor, ...cardsProps
    }
    return newProps
  }, [props])

  return withPortalProviders(MultiColumnsPortal, computedProps);
};
export default MultiColumns;
